import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const StyledDistanceContainerDiv = styled.div`
  ${rtl`
  padding-top: ${toRem(24)};
  `}
`;

export const StyledDistanceHeaderContainerDiv = styled.div`
  ${rtl`
  padding-top: ${toRem(24)};
  padding-bottom: ${toRem(24)};
  `}
`;

export const StyledDistanceItemsContainerDiv = styled.div`
  ${rtl`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  `}
`;

export const StyledDistanceItemDiv = styled.div`
  ${rtl`
  width: 50%;
  padding: ${toRem(8)} 0;
  &.disabled {
    opacity: 0.7;
    pointer-events:none;
  }
  .radio-container {
    margin-bottom:0;
    border-bottom: none;
    margin-left: 0;
    padding: 0;

    input[type='radio'] + label {
      &.checkbox-radio {
        margin-bottom: 0;
        border: 0;
        padding-bottom: 0;
        width: fit-content;
        padding-left: ${toRem(28)};
        font-size: ${toRem(14)};

        .item-name {
          padding-left: ${toRem(8)};
        }
      }
    }
  }
  @media only ${theme.mediaQuery.allTablets} {
    .radio-container {
      input[type='radio'] + label {
        &.checkbox-radio {
          outline: 0;
          .item-name {
            outline: none;
          }
        }
      }
    }
  }
  .radio-container {
    input[type=radio]:checked~label:before {
      outline: none;
    }
  }
  `}
`;
